import { Injectable } from '@angular/core';
import { IProductBootstrapService } from '../../common/services/product-bootstrap.service';
import { TableConfigurationOverrideService } from '../../common/services/table-configuration-override.service';
import { SideBarMenuService } from '../../common/services/side-bar-menu.service';
import { ComponentSlotRegistryService } from '../../common/services/component-slot-registry.service';
import { AdminUiSettings, ENTITY_DETAIL_OVERVIEW_SLOT } from '../../common/dtos';
import { getSkootMenuItems } from './skoot.menu-items';

@Injectable({
  providedIn: 'root',
})
export class SkootBootstrapService implements IProductBootstrapService {
  constructor(
    private readonly tableConfigService: TableConfigurationOverrideService,
    private readonly sideBarMenuService: SideBarMenuService,
    private readonly componentSlotRegistry: ComponentSlotRegistryService
  ) {
    // Do not initalize anything here. This service will be created regardless of product type.
  }

  initializeForProduct(settings: AdminUiSettings): void {
    this.registerMenuItems();
    this.registerEntitySlots();
  }

  registerEntitySlots(): void {
    this.componentSlotRegistry.register(ENTITY_DETAIL_OVERVIEW_SLOT, () =>
      import('./entity-extensions/skoot-entity-overview.component').then(
        (m) => m.SkootEntityOverviewComponent
      )
    );
  }

  registerMenuItems() {
    this.sideBarMenuService.registerMenuItems(getSkootMenuItems());
  }
}
